export default __webpack_public_path__ + "images/cephalic_blue.ec1f782f91e0e356f7d7077fc47c561a.png";